import { eventBus, EVENTS } from './EventBus.js';
import API from './Api.js';
let advRules = [];
let cachedAdvRules = {};
let refreshIdx = 0;


function getAdvRules() {
  return new Promise((resolve, reject) => {
    if (advRules.length) {
      resolve(advRules);
      return;
    }
    API.get('site/getAdvRules', {}, (data) => {
      advRules = data;
      resolve(advRules);
      return;
    });
  });
}

function getNativeAdvRule() {
  const location = window.location.pathname;
  const device = getDeviceType();
  const typeAdDisplay = isPageNative(location);
  if (typeAdDisplay == -1) {
    return false;
  }
  let formats = [];
  //Assetto ADV pagine native
  //0:solo SKIN-MPU
  //1:solo LEADERBOARD-MPU
  //2:solo LEADERBOARD
  //3:solo SKIN
  //4:solo LEADERBOARD-MPU-SKYSCRAPER
  //5:solo MPU
  //6:solo SKIN-LEADERBOARDMOBILE
  //7:solo SKIN-MPU-LEADERBOARD
  switch (typeAdDisplay) {
    case 0:
      formats.push({ name: 'skin', container: 'skinPh' });
      formats.push({ name: 'mpu', container: 'mpuPh' });
      break;
    case 1:
      formats.push({ name: 'leaderboard', container: 'leaderboardPh' });
      formats.push({ name: 'mpu', container: 'mpuPh' });
      break;
    case 2:
      formats.push({ name: 'leaderboard', container: 'leaderboardPh' });
      break;
    case 3:
      formats.push({ name: 'skin', container: 'skinPh' });
      break;
    case 4:
      formats.push({ name: 'leaderboard', container: 'leaderboardPh' });
      formats.push({ name: 'skin', container: 'skinPh' });
      formats.push({ name: 'skyscraper', container: 'skyscraperPh' });
      break;
    case 5:
      formats.push({ name: 'mpu', container: 'mpuPh' });
      break;
    case 6:
      formats.push({ name: 'leaderboard', container: 'leaderboardPh' });
      formats.push({ name: 'skin', container: 'skinPh' });
      break;
    case 7:
      formats.push({ name: 'skin', container: 'skinPh' });
      formats.push({ name: 'mpu', container: 'mpuPh' });
      formats.push({ name: 'lead_mobile', container: 'leaderboarmobiledPh' });
      break;
    default:
      break;
  }
  let rule = { device_type: device, formats: formats, isNative:true };
  return rule;
}

function getAdvRule() {
  const location = window.location.pathname;
  const device = getDeviceType();
  return new Promise((resolve, reject) => {
    let rule = cachedAdvRules[`${location}-${device}`];
    if (!rule) {
      rule = getNativeAdvRule();
    }
    if (!!rule) {
      resolve(rule);
      return;
    }
    getAdvRules().then((rules) => {
      rules = rules.filter(r => r.device_type == device).sort((a, b) => {
        if (a.rule.indexOf('*') == -1) {
          return -1;
        } else {
          return b.rule.indexOf('*') - a.rule.indexOf('*');
        }
      }).filter(r => {
        let rule = r.rule;
        if (rule == '') {
          rule = '/';
        }
        rule = '^' + rule + '$';
        const ruleRegex = new RegExp(rule.replace('*', '.+'));
        // console.log(ruleRegex, ruleRegex.test(location));
        return ruleRegex.test(location);
      })
      if (rules.length) {
        cachedAdvRules[`${location}-${device}`] = rules[0];
        resolve(rules[0]);
        return;
      } else {
        resolve(false);
        return;
      }
    });
  });
}

function getDeviceType() {
  const width = $(window).width();
  let deviceType = '';
  if (width >= 1280) {
    deviceType = 'Desktop';
  }
  else if (width >= 768 && width < 1280) {
    deviceType = 'Tablet';
  } else {
    deviceType = 'Mobile';
  }
  return deviceType;
}

eventBus.on(EVENTS.PAGE_BEFORE_LOADING, () => {
  getAdvRule().then(rule => {
    console.log('rule', rule);
  });
});

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
  if(refreshIdx%2>0){
    refreshIdx++;
    return;
  }
  refreshIdx++;
  console.log('refresh neodata');
  if (data.template == "single_post") {
  console.log('4W');
  window.call4wFn=true;
  (function($n,e,o,d,a,t,a$) {
      $n._4wRecom = $n._4wRecom || {};
      $n._4wRecom.Q = $n._4wRecom.Q || [];
      $n._4wRecom.Q.push(['setup', function () {
          $n._4wRecom.T.setTaxonomy("/rds/rds/rds.it/entertainment");
          $n._4wRecom.T.setMetaKeywords("article:tag");
          $n._4wRecom.B.addPosition("rds_rds_entertainment","NeoWidget");
      }]);
      var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
      x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js')+o;
      x.async = a;
      s.parentNode.insertBefore(x, s);

  })(window,'scr'+'ipt','.neodatagroup.com/4wr.js',document,1,location,1);
}
  getAdvRule().then(rule => {
    $('.rdsadv').html('');
    // console.log('rule', rule);
    if (rule) {

      // console.log(data.template);
      (function ($n, e, o, d, a, t, a$) {
        $n._neoRds = $n._neoRds || {};
        $n._neoRds.Q = $n._neoRds.Q || [];
        // Defines setup function
        $n._neoRds.Q.push(['setup', function () {
          let x = $n._neoRds.B.reset();
          x = x.loadMapper();
          if(rule.isNative){
            x = x.setLocationBase('rsn_rds_native_native');
          }
          for (let i = 0; i < rule.formats.length; i++) {
            if ((data.template == "magazine" || data.template == "magazine-category") && rule.formats[i].name == "mpu") {
              let mpu = '<div class="single_ultime_news_magazine mpu-news"><div class="medium-rectangle" style="margin-top: 0;">\n' +
                '                      <div class="medium-inside">\n' +
                '                      <div id="mpuPh" style=" margin: 0;" class="adv_mpu contents-single rdsadv"></div>\n' +
                '                      <!-- <img class="medium-content" src="https://ac.neodatagroup.com/img_uploads/507/89_626507_1_song_test_300_x_250.jpg"></img> -->\n' +
                '                      </div>\n' +
                '                      </div></div>';
              // $(".single_ultime_news_magazine:nth-child(6)").hide();
              const position = getDeviceType() == 'Tablet' ? 2 : 1
              $("#magazine-simple_post_recenti").find(`.single_ultime_news_magazine:nth-child(${position})`).after(mpu);
              $("#magazine-simple_post_recenti .single_ultime_news_magazine:last-child").hide();
            } else if (data.template == "homepage" && rule.formats[i].name == "mpu" && getDeviceType() == 'Tablet') {
              jQuery('#mpuPh').remove();
              let mpu = `
                  <div class="single_ultime_news mpu-news">
                    <div id="mpuPh" style=" margin: 0;" class="adv_mpu contents-single rdsadv"></div>
                  </div>`;
              $("#homepage-simple_ultime_notizie").find(`.single_ultime_news:nth-child(1)`).after(mpu);
              $("#homepage-simple_ultime_notizie .single_ultime_news:last-child").hide();
            } else if (data.template == "eventi" && rule.formats[i].name == "mpu") {
              let mpu = `
                  <div class="container-content clickable eventi eventi_mpu">
                    <div id="mpuPh" style=" margin: 0;" class="adv_mpu contents-single rdsadv"></div>
                  </div>`;
              $("#eventi-blocco_evento_passato").prepend(mpu);
            }
            const format = rule.formats[i];
            x = x.addPosition(format.name, format.container);
          }


          // x=x.addPosition("mpu", "mpuPh");
          // x=x.addPosition("leaderboard", "leaderboardPh")
          x.refresh()
        }]);
        // Here Javascript Library is loaded
        var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
        x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
        x.async = a;
        s.parentNode.insertBefore(x, s);

      })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    }

  });
});


